module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0044.jpg?v=0bdd9cd2";